import { gql } from 'graphql-tag';
export const PURCHASEABLES_FOR_ITEM_GET = gql `
  query resolveProductsAndSubscriptions($item: ChildDto!) {
    purchaseables: resolveProductsAndSubscriptions(
      item: $item
    ) {
      id
      title
      description
      price
      productType
      period
      purchaseUrl
  		externalIdentifiers {
        id
        identifier
        store
        purchaseUrl
        allowPurchaseWithoutAuthentication
      }
    }
  }
`;
export const FINALIZE_PURCHASE = gql `
  mutation finalizePurchase(
    $channel: Channel!,
    $data: json!
  ) {
    finalizePurchase(
      channel: $channel,
      data: $data,
    ) {
      isValid
      extraData
    }
  }
`;
export const MANAGE_PURCHASES_GET = gql `
  query managePurchases {
    managePurchases {
      url
      channel
    }
  }
`;
//# sourceMappingURL=purchase.js.map